<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('service.edit') }}</h3>
    </div>
    <div class="modal-content">
      <form
        id="form-create-user"
        action=""
      >
        <div class="input-group">
          <div class="input input-select">
            <label for="deviceID">{{ $t('service') }}</label>
            <div class="btn-select">
              <select
                id="deviceID"
                v-model="device.service"
              >
                <option
                  v-for="service in services"
                  :key="service.id"
                  :selected="service.id === device.service"
                  :value="service.id"
                >
                  {{ service.title['pt'] }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="editDevice()"
          >
            {{ $t('update') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'EditDevice',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    device: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['services'])
  },
  methods: {
    ...mapActions([
      'fetchDevices'
    ]),
    async close () {
      this.$emit('input', false)
    },
    async editDevice () {
      await api.updateDevice({ deviceID: this.device.id, service: this.device.service })
      this.fetchDevices({ status: 'all' })
      await this.close()
    }
  }
}
</script>
